/**
 * @param email {string}
 * @param domains {string[]}
 * @return {boolean}
 */
module.exports = function doesEmailContainOneOfDomains(email, domains) {
    for (let i = 0; i < domains.length; i++) {
        const domain = domains[i];

        const check = domain && email.endsWith(domain);

        if (check) {
            return true;
        }
    }

    return false;
}